// @flow
import config from 'config'

export const getMagazineListPath = (page: number, category: string) => {
  if (!page && !category) return config.prefix + '/magazin/'
  if (!category) return config.prefix + `/magazin/page/${page + 1}/`
  if (!page) return config.prefix + `/magazin/${category.toLowerCase()}/`
  return config.prefix + `/magazin/${category.toLowerCase()}/page/${page + 1}/`
}
